import { render, staticRenderFns } from "./bind-business.vue?vue&type=template&id=4731e0ee&scoped=true"
import script from "./bind-business.vue?vue&type=script&lang=ts"
export * from "./bind-business.vue?vue&type=script&lang=ts"
import style0 from "./bind-business.vue?vue&type=style&index=0&id=4731e0ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4731e0ee",
  null
  
)

export default component.exports